import axios from 'axios';
import axiosRetry from 'axios-retry';
import toastr from 'toastr';
import * as actions from './actionsTypes';
import errorManage from '../errorManage';
import messages from '../../redux/messages';

const client = axios.create({ baseURL: process.env.REACT_APP_URL });
axiosRetry(client, { retries: 5, retryDelay: axiosRetry.exponentialDelay });

export const getChecklist = (params,itype) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_CHECKLIST,
      payload: true
    });
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.get( itype === 1 ? `/api/app/Formal_Check_List/` : `/api/app/Funcional_Check_List/`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      },
      params: params
    });
    dispatch({
      type: actions.GET_CHECKLIST,
      payload: resp.data
    });
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.LOADING_CHECKLIST,
      payload: false
    });
  }
}

export const saveCheckList = (data, itype) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_CHECKLIST,
      payload: true
    });
    
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.post(itype === 1 ? `/api/app/Formal_Check_List/`: '/api/app/Funcional_Check_List/', data, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      }});
    const { checklist } = getState().checklistDocs;
    const aChecklist = [...checklist, resp.data];
    dispatch({
      type: actions.GET_CHECKLIST,
      payload: aChecklist
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.SAVE_LOADER_CHECKLIST,
      payload: false
    });
  }
}

export const editChecklist = (data, itype, index, id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_CHECKLIST,
      payload: true
    });
    
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.put(itype === 1 ? `/api/app/Formal_Check_List/${id}/`: `/api/app/Funcional_Check_List/${id}/`, data, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`
    }});
    
    const { checklist } = getState().checklistDocs;
    checklist[index] = resp.data;
    //const aCheck = [...checklist, resp.data];
    dispatch({
      type: actions.GET_CHECKLIST,
      payload: checklist
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.SAVE_LOADER_CHECKLIST,
      payload: false
    });
  }
}

export const deleteChecklist = (id, index, itype) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_CHECKLIST,
      payload: true
    });
  
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    await client.delete(itype === 1 ? `/api/app/Formal_Check_List/${id}/`: `/api/app/Funcional_Check_List/${id}/`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`
    }});
    const { checklist } = getState().checklistDocs;
    checklist.splice(index, 1);
    //const aJobPositions = [...jobPositions, resp.data];
    dispatch({
      type: actions.GET_CHECKLIST,
      payload: checklist
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.LOADING_CHECKLIST,
      payload: false
    });
  }
}
